<template>
    <f7-page>
        <f7-navbar title="home" back-link="返回"></f7-navbar>
    </f7-page>
</template>

<script type="text/ecmascript-6">
  import { f7Page, f7Link } from 'framework7-vue'
  import { globalConst as native } from '../lib/const'

  export default {
    data () {
      return {}
    },
    created () {
    },
    methods: {
      go () {
        console.log('this', this)
        this.$f7.dialog.alert('ces', 'hi', () => {
          this.$f7router.navigate('/error')
        })
      },
      doConfig () {
        alert(WeixinJSBridge)
        WeixinJSBridge.invoke('configWXDeviceWiFi', {}, function (res) {
          alert(res.err_msg)
          // var err_msg = res.err_msg
          // alert(res)
        })
      }
    },
    computed: {},
    destroyed () {
      console.log('home destroyed')
    },
    components: {f7Page, f7Link}
  }
</script>
<style lang="scss" scoped type="text/css">
</style>
